import { create } from "zustand";
import axios from "axios";

const activityLogStore = create((set, get) => ({
    activityLog: [],

    activityLogForm: {
        seriesId: "",
        userStatus: "",
    },

    fetchActivityLog: async () => {
        // Fetch the status
        const res = await axios.get("/activity-log");

        // Set to state
        set({ activityLog: res.data.activityLog || [] }); //check this
    },

    createActivityLog: async(seriesId, userStatus) => {
        try {
            let res = await axios.post(`/activity-log`, { seriesId, userStatus });

            // Add new one to local state
            set((state) => ({
                activityLog: [...state.activityLog, res.data.activityLog]
            }));
            
        } catch (err) {
            console.log("Create Activity Log Error");
            return err;
        }
    },
}));

export default activityLogStore;